import { render, staticRenderFns } from "./changeBatch.vue?vue&type=template&id=d3d824f0&scoped=true"
import script from "./changeBatch.vue?vue&type=script&lang=js"
export * from "./changeBatch.vue?vue&type=script&lang=js"
import style0 from "./changeBatch.vue?vue&type=style&index=0&id=d3d824f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d824f0",
  null
  
)

export default component.exports